{
  "title": "Widogast's Transmogrification (HB)",
  "source": "Critical Role (Twitter)",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 hour",
  "range": "Touch",
  "components": "V, S, M (Damp clay equal to the weight of the target and 150 gp worth of crushed gem dust, both of which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You permanently alter the physical body of a humanoid creature into another type of humanoid body. After encasing the target in clay, you conduct a rigorous, one-hour-long ritual that manipulates the flesh and function of the target's body into that of another humanoid race. They lose their previous racial traits and instead gain the racial traits of another humanoid race of the target's choice, aside from languages known (which remain unchanged). Should the target wish to alter their gender along with or instead of their race, they can choose to do so as part of the spell. When the ritual is completed, you and the target suffer one level of exhaustion.",
    "Once a creature's race or gender has been changed via this spell, they cannot be affected again by this spell for 1 year."
  ],
  "spellLists": ["wizard"]
}
